export default "__VITE_ASSET__BgTW_A83__"